import React from "react";
import moment from "moment";
import { Tooltip } from "react-tooltip";
import atoms from "../../atoms";
import { FeedbackFormProps, FeedbackRow } from "./interface";

const { Table, Pagination } = atoms;

const Index = ({
    feedbacks,
    currentPage,
    setCurrentPage,
    setLimitPerPage,
    limitPerPage,
}: FeedbackFormProps) => {
    const columns = [
        {
            name: "Customer Name",
            selector: (row: FeedbackRow) => (row?.customer_name ? row?.customer_name : "-"),
            sortable: true,
        },
        { name: "Email", selector: (row: FeedbackRow) => (row?.email ? row?.email : "-") },
        {
            name: "Contact Number",
            selector: (row: FeedbackRow) => (row?.contact_number ? row?.contact_number : "-"),
        },
        {
            name: "Invoice Number",
            selector: (row: FeedbackRow) =>
                `${row?.invoice_number ? row?.invoice_number : "-"}`,
        },
        {
            name: "Store Name",
            selector: (row: FeedbackRow) => `${row?.store_name ? row?.store_name : "-"}`,
        },
        {
            name: "Rating",
            selector: (row: FeedbackRow) => (row?.rating ? row?.rating : "-"),
        },
        {
            name: "Suggestions",
            selector: (row: FeedbackRow) => (
                <>
                    <Tooltip id={`tooltip-${row?.id}`} />
                    <div
                        data-tooltip-id={`tooltip-${row?.id}`}
                        data-tooltip-content={row?.suggesstions}
                    >
                        {row?.lens_data?.heading?.length > 50
                            ? row?.suggesstions?.substring(0, 50) + "..."
                            : row?.suggesstions}
                    </div>
                </>
            ),
            minWidth: "150px",
        },
        {
            name: "Date",
            selector: (row: any) =>
                row?.createdAt ? moment(row?.createdAt).format("DD/MM/YYYY") : "-",
        },
    ];

    return (
        <>
            {feedbacks?.data && feedbacks?.data?.length > 0 ? (
                <div>
                    <Table
                        className="adjustable-row-height"
                        columns={columns}
                        data={feedbacks?.data}
                    />
                </div>
            ) : (
                <div className="justify-content-center d-flex mt-5 ">
                    There are no records to display
                </div>
            )}
            <Pagination
                totalCount={feedbacks?.count}
                currentPage={currentPage}
                totalPages={feedbacks?.totalPages}
                onChangePage={(page: number) => setCurrentPage(page)}
                setLimit={(e: number) => setLimitPerPage(e)}
                limit={limitPerPage}
            />
        </>
    );
};

export default Index;
